import classes from './RemarkEditor.module.css'
import React, { useRef, useState, useEffect } from 'react';
import {
  RichTextEditorComponent,
  Toolbar,
  Link,
  HtmlEditor,
  QuickToolbar,
  Inject
} from '@syncfusion/ej2-react-richtexteditor';
import syncfusionConfig from '../../../ActionsSubmission/SyncfusionConfig.js';
import { useSelector } from 'react-redux';

const RemarkEditor = ({ setRemarks, remarks, isGroup }) => {
    const editorRef = useRef(null);
    const [localData, setLocalData] = useState(remarks || '');
    const { texts } = useSelector(state => state.translate);

    useEffect(() => {
        setLocalData(remarks || '');
    }, [remarks]);

    useEffect(() => {
        if (localData !== remarks) {
            setRemarks(localData);
        }
    }, [localData, setRemarks]);

    return (
        <>
            <div className={classes.SyncfusionEditorTitle}>{isGroup ? texts.writeTeamAssessment : texts.writePersonalAssessment}</div>
            <RichTextEditorComponent
                ref={editorRef}
                value={localData}
                change={(e) => {
                    if (e.action !== 'tab') {
                        setLocalData(e.value);
                    }
                }}
                {...syncfusionConfig}
            >
                <Inject services={[Toolbar, Link, HtmlEditor, QuickToolbar]} />
            </RichTextEditorComponent>
        </>
    )
}
export default RemarkEditor